import { Component, ViewChild, Input, inject } from '@angular/core';
import { FilterListComponent } from 'gung-list';
import { OrderListConfigService } from '../../services/order-list-config/order-list-config.service';
import { Order } from '../../models/order';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'lib-order-list',
    template: `<lib-filter-list #orderList [configService]="orderListConfigService"></lib-filter-list>`,
    styleUrls: ['./order-list.component.scss'],
    standalone: false
})
export class OrderListComponent {
  public orderListConfigService = inject(OrderListConfigService);
protected route = inject(ActivatedRoute);

constructor() {
  const customerId = this.route.snapshot.params.customerId;

  if (customerId != null) {
    this.orderListConfigService.setCustomerId(customerId);
  } else {
    this.orderListConfigService.setCustomerId(null);
  }
}
  @ViewChild('orderList') orderList: FilterListComponent<Order>;
}
